import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SchoolService } from '../../schools/services/school-service/school-service';
import { LicenseStateService } from '../services/license-state-service/license-state-service';
import { LicenseFeature } from '../../school-license/models/license-feature.model';

/**
 * Drží stránku prodávanou jen s některými licencemi mimo dosah škol, které takovou licenci nemají —
 * widget na úvodní stránce ji zamyká, tohle zavírá i cestu přímo přes URL.
 *
 * Čeká na první načtení seznamu škol: bez něj není o licenci nic známo a škola s PREMIUM by se
 * odrazila od vlastního kurzu.
 *
 * Posuzuje školu vybranou v hlavičce, ne `LicenseStateService.currentSchool`: guard běží ještě
 * před zničením opouštěné stránky, takže při odchodu z rozpracovaného (nebo neúspěšně načteného)
 * ŠVP by `currentSchool` bylo `null` a licencovaná škola by se od kurzu odrazila.
 */
export function licenseFeatureGuard(feature: LicenseFeature): CanActivateFn {
  return async () => {
    const schoolService = inject(SchoolService);
    const licenseState = inject(LicenseStateService);
    const router = inject(Router);

    await schoolService.whenLoaded;

    return licenseState.featureUnavailableFor(feature, schoolService.selectedSchoolId())
      ? router.createUrlTree(['/'])
      : true;
  };
}
